import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { PageTitle } from "../../components/Layout";
import { Field, Select } from "../../components/ui-modal";
import { toast } from "sonner";
import * as Icons from "lucide-react";

export default function AdminNotify() {
  const [clients, setClients] = useState([]);
  const [collabs, setCollabs] = useState([]);
  const [form, setForm] = useState({ target: "client", recipient_id: "", subject: "", body: "" });
  useEffect(() => { api.get("/admin/clients").then((r) => setClients(r.data)); api.get("/admin/collaborators").then((r) => setCollabs(r.data)); }, []);

  const send = async (e) => {
    e.preventDefault();
    await api.post("/admin/broadcast", form);
    toast.success("Notification envoyée");
    setForm({ ...form, subject: "", body: "" });
  };
  const recipients = form.target === "collaborator" ? collabs : clients;

  return (
    <div className="max-w-xl">
      <PageTitle overline="Communication" title="Notifications" />
      <form onSubmit={send} className="bg-sable rounded-sm border border-marine/10 shadow-sm p-6 space-y-4">
        <Select label="Destinataire" value={form.target} onChange={(v) => setForm({ ...form, target: v, recipient_id: "" })} options={[{ v: "client", l: "Une entreprise" }, { v: "all_clients", l: "Toutes les entreprises" }, { v: "collaborator", l: "Un collaborateur" }]} testid="notify-target" />
        {form.target !== "all_clients" && (
          <Select label="Sélectionner" value={form.recipient_id} onChange={(v) => setForm({ ...form, recipient_id: v })} options={[{ v: "", l: "—" }, ...recipients.map((r) => ({ v: r.id, l: r.name }))]} testid="notify-recipient" />
        )}
        <Field label="Objet"><input required value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} data-testid="notify-subject" className="inp" /></Field>
        <Field label="Message"><textarea required rows={6} value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} data-testid="notify-body" className="inp" /></Field>
        <button data-testid="notify-send" className="bg-marine text-white rounded-sm px-5 py-2.5 text-sm hover:bg-marine-hover flex items-center gap-2"><Icons.Send size={16} /> Envoyer</button>
      </form>
    </div>
  );
}
